import useTranslation from '../../hooks/useTranslations';
import { LoadingIcon, MSDIcon } from './icons/Icons';

const LoadingScreen = ({ bgColor = 'bg-oly-gray-lightestAlpha45' }) => {
	const t = useTranslation();

	return (
		<div className={`flex flex-col items-center justify-center w-full h-screen ${bgColor}`}>
			<MSDIcon className="mx-auto mb-4 lg:mb-6 w-42 h-14 sm:w-60 sm:h-20 text-oly-blue-dark" />
			<div className="flex items-center justify-center">
				<h2 className="pl-1 mr-2 lg:mr-3 text-[1.4375rem] lg:text-[1.875rem] text-oly-blue-dark">
					{t('general_loading')}
				</h2>
				<LoadingIcon className="w-6 h-6 text-oly-blue-dark animate-spin" />
			</div>
		</div>
	);
};

export default LoadingScreen;
